export const policyList = {
  createPermissionProfile:
    "permissionsProfileManagement.createPermissionProfile",
  modifyPermissionProfile:
    "permissionsProfileManagement.modifyPermissionProfile",
  viewLocations: "locationsManagement.viewLocations",
  createLocations: "locationsManagement.createLocations",
  modifyLocations: "locationsManagement.modifyLocations",
  deleteLocations: "locationsManagement.deleteLocations",
  viewUsers: "userManagement.viewUsers",
  createUsers: "userManagement.createUsers",
  modifyUsers: "userManagement.modifyUsers",
  deleteUsers: "userManagement.deleteUsers",
  viewAccountManagement: "accountManagement.viewAccountManagement",
  payBill: "accountManagement.payBill",
  toggleAutoBillPay: "accountManagement.toggleAutoBillPay",
  viewUserSeats: "accountManagement.viewUserSeats",
  modifyUserSeats: "accountManagement.modifyUserSeats",
  viewLocationSeats: "accountManagement.viewLocationSeats",
  modifyLocationSeats: "accountManagement.modifyLocationSeats",
  viewPrintInvoice: "accountManagement.viewPrintInvoice",
  manageQuickbooksIntegration: "apiManagement.manageQuickbooksIntegration",
  createATicket: "support.createATicket",
  viewCreditCards: "accountManagement.viewCreditCards",
  createCreditCards: "accountManagement.createCreditCards",
  modifyCreditCards: "accountManagement.modifyCreditCards",
  deleteCreditCards: "accountManagement.deleteCreditCards",
  viewApiManagement: "integrationsManagement.viewApiManagement",
  createApiToken: "integrationsManagement.createApiToken",
  revokeApiToken: "integrationsManagement.revokeApiToken",
  viewPermissionProfiles: "permissionsProfileManagement.viewPermissionProfiles",
  deletePermissionProfile:
    "permissionsProfileManagement.deletePermissionProfile",
  viewPmpIntegration:
    "apiManagement.viewPrescriptionMonitoringProgramIntergration",
  modifyPmpIntegration:
    "apiManagement.modifyPrescriptionMonitoringProgramIntergration",
  viewStateTraceabilityIntegrations:
    "apiManagement.viewStateTraceabilityIntegrations",
  modifyStateTraceabilityIntegrations:
    "apiManagement.modifyStateTraceabilityIntegrations"
};
